export default __webpack_public_path__ + "static/merchandising-94c6706fccfd8c1b41e02fc63be435c5.png";